const themes = {
	violet: {
		base: '#160d2e',
		primary: '#6c50b9',
		secondary: '#352463',
		progressBg: '#231252',
		progress: '#68b538',
		tab: '#9a74ff',
		activeListItem: '#4a2e95',
		scrollThumb: '#4a2e95',
		scrollTrack: '#2b195c'
	},

	blue: {
		base: '#0d1431',
		primary: '#3365e2',
		secondary: '#1f389f',
		progressBg: '#15266b',
		progress: '#68b538',
		tab: '#5988ff',
		activeListItem: '#3365e2',
		scrollThumb: '#3365e2',
		scrollTrack: '#1f389f'
	},

	orange: {
		base: '#280f02',
		primary: '#d56901',
		secondary: '#8d2d04',
		progressBg: '#581900',
		progress: '#68b538',
		tab: '#ffb32e',
		activeListItem: '#d56901',
		scrollThumb: '#d56901',
		scrollTrack: '#8f2906'
	},

	green: {
		base: '#0b1e03',
		primary: '#35b21b',
		secondary: '#235f0a',
		progressBg: '#133405',
		progress: '#68b538',
		tab: '#2bf200',
		activeListItem: '#31b414',
		scrollThumb: '#31b414',
		scrollTrack: '#235f0a'
	},

	grey: {
		base: '#191919',
		primary: '#6d869a',
		secondary: '#3f4d58',
		progressBg: '#222e39',
		progress: '#68b538',
		tab: '#8ca5b9',
		activeListItem: '#6e879b',
		scrollThumb: '#6e879b',
		scrollTrack: '#4a5965'
	},

	red: {
		base: '#240508',
		primary: '#b92130',
		secondary: '#730d17',
		progressBg: '#3c070c',
		progress: '#68b538',
		tab: '#fc5263',
		activeListItem: '#b92130',
		scrollThumb: '#b92130',
		scrollTrack: '#690913'
	},

	pink: {
		base: '#2c0017',
		primary: '#fc4280',
		secondary: '#b21c4d',
		progressBg: '#710b2c',
		progress: '#68b538',
		tab: '#ff9cb6',
		activeListItem: '#fc4280',
		scrollThumb: '#fc4280',
		scrollTrack: '#991e47'
	},

	purple: {
		base: '#24002a',
		primary: '#e334ff',
		secondary: '#820e95',
		progressBg: '#630772',
		progress: '#68b538',
		tab: '#ea62ff',
		activeListItem: '#d519f3',
		scrollThumb: '#d519f3',
		scrollTrack: '#850e98'
	},

	turquoise: {
		base: '#042422',
		primary: '#0faba0',
		secondary: '#035e58',
		progressBg: '#01322f',
		progress: '#68b538',
		tab: '#35e6c7',
		activeListItem: '#05a495',
		scrollThumb: '#05a495',
		scrollTrack: '#035e58'
	},

	yellow: {
		base: '#241d00',
		primary: '#f7bc09',
		secondary: '#bc7800',
		progressBg: '#5e3e00',
		progress: '#68b538',
		tab: '#ffee31',
		activeListItem: '#f7bc09',
		scrollThumb: '#f7bc09',
		scrollTrack: '#b37200'
	},
};

// const violet = {
// 	base: '#160d2e',
//     primary: '#6c50b9',
//     secondary: '#352463',
//     progressBg: '#231252',
//     progress: '#68b538'
// };

// const blue = {
// 	base: '#0d1431',
//     primary: '#3365e2',
//     secondary: '#1f389f',
//     progressBg: '#15266b',
//     progress: '#68b538'
// };

// const red = {
//     base: '#280f02',
//     primary: '#d56901',
//     secondary: '#8d2d04',
//     progressBg: '#581900',
//     progress: '#68b538'
// }

// const orange = {
//     base: '#280f02',
//     primary: '#d56901',
//     secondary: '#8d2d04',
//     progressBg: '#581900',
//     progress: '#68b538'
// }

module.exports = {
	themes,
};
